export default "__VITE_ASSET__DuMi1aTP__"